import { Route } from "react-router-dom";
import ProviderSearchForm from "../components/index";

const ProviderSearchFormRoutes = () => (
  <>
    <Route path="search_form" element={<ProviderSearchForm />} />
  </>
);


export default ProviderSearchFormRoutes;